import { motion } from 'framer-motion';
import { Wrench, Clock, Mail, Settings } from 'lucide-react';

export const MaintenancePage = ({ message, endTime }) => {
  const formatEndTime = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return date.toLocaleString('es-ES', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-lg"
      >
        {/* Animated icon */}
        <motion.div
          animate={{ rotate: [0, 10, -10, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          className="w-24 h-24 mx-auto mb-8 bg-amber-500/10 rounded-full flex items-center justify-center"
        >
          <Wrench className="w-12 h-12 text-amber-500" />
        </motion.div>

        {/* Title */}
        <h1 className="font-serif text-4xl md:text-5xl mb-4 tracking-tight">
          En Mantenimiento
        </h1>

        {/* Message */}
        <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
          {message || "Estamos realizando mejoras en la web. Volvemos pronto."}
        </p>

        {/* End time */}
        {endTime && (
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-sm text-muted-foreground mb-8">
            <Clock className="w-4 h-4" />
            <span>Estimación: {formatEndTime(endTime)}</span>
          </div>
        )}

        {/* Divider */}
        <div className="w-16 h-px bg-border mx-auto mb-8" />

        {/* Contact */}
        <p className="text-sm text-muted-foreground mb-4">
          Si tienes alguna urgencia, puedes contactarme en:
        </p>
        <a 
          href="mailto:jonquintano.fotografia@gmail.com"
          className="inline-flex items-center gap-2 text-foreground hover:text-foreground/80 transition-colors"
        >
          <Mail className="w-4 h-4" />
          jonquintano.fotografia@gmail.com
        </a>

        {/* Logo */}
        <div className="mt-12 pt-8 border-t border-border">
          <p className="font-serif text-xl tracking-wider">Jon Quintano</p>
          <p className="text-xs text-muted-foreground uppercase tracking-widest mt-1">Fotografía</p>
        </div>

        {/* Admin access button */}
        <a
          href="/admin"
          data-testid="admin-panel-btn"
          className="mt-8 inline-flex items-center gap-2 px-4 py-2 text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors"
        >
          <Settings className="w-3 h-3" />
          Panel de administración
        </a>
      </motion.div>
    </div>
  );
};

export default MaintenancePage;
